import { Routes } from '@angular/router';
import { AdminGuard, AdminOnlyGuard } from './guards/admin.guard';
import { AdminLayoutComponent } from './layout/admin-layout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('@app/pages/login/login.page').then(m => m.LoginPage),
    data: { isAdmin: true },
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      { path: 'dashboard', canActivate: [AdminOnlyGuard], loadComponent: () => import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage) },
      { path: 'users', canActivate: [AdminOnlyGuard], loadComponent: () => import('./pages/users/users.page').then(m => m.UsersPage) },
      { path: 'activity-log', canActivate: [AdminOnlyGuard], loadComponent: () => import('./pages/activity-log/activity-log.page').then(m => m.ActivityLogPage) },
      { path: 'modules', redirectTo: 'modules-management', pathMatch: 'full' },
      { path: 'modules-management', loadComponent: () => import('./pages/modules/modules.page').then(m => m.ModulesPage) },
      { path: 'notes', loadComponent: () => import('./pages/notes/notes.page').then(m => m.NotesPage) },
      { path: 'notes/create', loadComponent: () => import('./pages/notes/note-editor/note-editor.page').then(m => m.NoteEditorPage) },
      { path: 'notes/edit/:id', loadComponent: () => import('./pages/notes/note-editor/note-editor.page').then(m => m.NoteEditorPage) },
      { path: 'attachments', loadComponent: () => import('./pages/attachments/attachments.page').then(m => m.AttachmentsPage) },
      // Legacy bookmarks now open the unified Note Page experience.
      { path: 'page-builder', redirectTo: 'notes/create', pathMatch: 'full' },
      { path: 'decision-tree', loadComponent: () => import('./pages/decision-tree/decision-tree.page').then(m => m.DecisionTreePage) },
      //{ path: 'pdf-studio', loadComponent: () => import('./pages/pdf-studio/pdf-studio.page').then(m => m.PdfStudioPage) },
    ],
  },
];
